import { render } from "./levitateLoginCard.vue?vue&type=template&id=1220a89b&scoped=true"
import script from "./levitateLoginCard.vue?vue&type=script&lang=js"
export * from "./levitateLoginCard.vue?vue&type=script&lang=js"

import "./levitateLoginCard.vue?vue&type=style&index=0&id=1220a89b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1220a89b"]])

export default __exports__